import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello Everyone, I am <span className="purple">Subhayan Das </span>
            from <span className="purple"> Gurgaon, India.</span>
            <br />I am a junior pursuing Bachelor of Technology in Computer Science at <span className="purple">Kalinga Institute of Industrial Technology, Bhubaneshwar</span>.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Read about New Technologies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Cooking
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "An investment in knowledge pays the best interest."{" "}
          </p>
          <footer className="blockquote-footer">Benjamin Franklin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
